import React, { createContext, useMemo } from "react";
import usePortalHubConnectionManager from "../hooks/usePortalHub/usePortalHubConnectionManager";

export const HubContext = createContext();

const HubProvider = ({ children }) => {
  const { isOpen, portalHub } = usePortalHubConnectionManager();

  const contextValue = useMemo(
    () => ({ portalHub, Connected: isOpen }),
    [portalHub, isOpen]
  );

  return (
    <HubContext.Provider value={contextValue}>
      {children}
    </HubContext.Provider>
  );
};

export default HubProvider;
